module.exports = __webpack_public_path__ + "img/34_18.f197d9d8.png";